function add_to_selection(form, withChildren, removeFromSelectionWhenFoundInTable = false, idField = 'id') {
    withChildren = withChildren === undefined ? false : withChildren;
    const $ = jQuery.noConflict();
    form = $(form);
    const data = form.serializeJSON();
    const table = form.parents('table');
    const parent = table.parent();
    const classSelector = '.' + table.attr('class').split(' ').join('.');

    let filter_name = table.attr('data-filters-key');
    if(filter_name === undefined) {
        filter_name = get_unique_id();
        table.attr('data-filters-key',filter_name);
    }

    const select = form.find('select');
    select.val('-1').trigger('change');
    const filterKey = select.attr('data-filter-key');
    const name = select.attr('name');
    const id = data[name];

    const addHiddenInput = function(id) {
        if (!parseInt(id)) return;
        const query = `input[name="selected_${name}s\[\]"][value="${id}"][data-${filter_name}-filter]`;
        if (table.parent().find(query).length === 0) {
            table.after('<input type="hidden" name="selected_' + name + 's[]" value="' + id + '" data-' + filter_name + '-filter />');
        }
    };


    const afterEverythingLoaded = function() {

        table.reloadThisElement(function() {
            const table = parent.find('table' + classSelector + ':first');

            table.find('tr[data-id]').each(function() {
                if (removeFromSelectionWhenFoundInTable) {
                    const data = $(this).getThisElementsData();
                    const val = data[idField];
                    // console.log({val});
                    // console.log(table.parent().find('input[value="' + val + '"][data-' + filter_name + '-filter]').length);
                    table.parent().find('input[value="' + val + '"][data-' + filter_name + '-filter]').remove();
                } else {
                    const id = $(this).attr('data-id');
                    if (table.find('input[value="' + id + '"][data-' + filter_name + '-filter]').length === 0) {
                        addHiddenInput(id);
                    }
                }
            });
        });

    };

    if (withChildren === false) {
        addHiddenInput(id);
        afterEverythingLoaded();
    } else {
        $.get('/companies/getAllChildrenOf/' + id, function(childIds) {
            childIds.forEach(function(id) {
                addHiddenInput(id);
            });
            afterEverythingLoaded();
        });
    }

    const subScreen = table.parents('.sub-screen-wrapper');
    if (subScreen[0] && !subScreen[0].modelSelectionMutationObserver && filterKey) {
        let debouncedFn;
        subScreen[0].modelSelectionMutationObserver = new MutationObserver(function() {
            if (debouncedFn) {
                debouncedFn.cancel();
            }
            debouncedFn = _.debounce(() => {
                // remove the current not_in filter for the selector
                table.parent().find(`input[name="not_in[]"][data-${filterKey}-filter]`).remove();

                // console.log(`[data-${filter_name}-filter][name="selected_${name}s[]"]`);
                // copy the selection to a not_in filter for the selector
                table.parent().find(`[data-${filter_name}-filter][name="selected_${name}s[]"]`).each(function() {
                    const input = $(this);
                    const value = input.val();
                    if (table.parent().find(`input[name="not_in[]"][value="${value}"][data-${filterKey}-filter]`).length === 0) {
                        table.after(`<input type="hidden" name="not_in[]" value="${value}" data-${filterKey}-filter />`);
                    }
                })
            }, 200);
            debouncedFn();
        });
        subScreen[0].modelSelectionMutationObserver.observe(table[0], {childList: true, subtree: true});
    }

    return false;
}
